// Libraries
import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
// Styles
import * as styles from './hero.module.css';
// Utils
import * as Constants from '../utils/constants';

class Hero extends React.Component {
  render() {
    const {
      image,
      useImageTag,
      className,
      detailsClassName,
      titleClassName,
      contentClassName,
      style,
    } = this.props;

    const classes = (base, override) =>
      override ? `${base} ${override}` : base;

    return (
      <div className={classes(styles.hero, className)} style={style}>
        {image && !useImageTag ? (
          <GatsbyImage
            className={styles.image}
            alt={this.props.title}
            image={image}
          />
        ) : (
          <img
            className={styles.image}
            alt="Hero"
            src={image || '/hero.webp'}
          />
        )}
        <div className={classes(styles.details, detailsClassName)}>
          <h1 className={classes(styles.title, titleClassName)}>
            {this.props.title}
          </h1>
          <p className={classes(styles.content, contentClassName)}>
            {this.props.content}
          </p>
        </div>
      </div>
    );
  }
}

Hero.defaultProps = {
  title: Constants.SITE_NAME,
  content: 'Musings on fantastic worlds & distant lands...',
};

export default Hero;
